import { render, staticRenderFns } from "./header-component.vue?vue&type=template&id=0f15f4cb&scoped=true&"
import script from "./header-component.vue?vue&type=script&lang=ts&"
export * from "./header-component.vue?vue&type=script&lang=ts&"
import style0 from "./header-component.vue?vue&type=style&index=0&id=0f15f4cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15f4cb",
  null
  
)

export default component.exports